"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
exports.__esModule = true;
var react_1 = require("react");
var useWillUnmount_1 = __importDefault(require("../useWillUnmount"));
function useRafState(initialState) {
  var ref = (0, react_1.useRef)(0);
  var _a = (0, react_1.useState)(initialState),
    state = _a[0],
    setState = _a[1];
  var setRafState = (0, react_1.useCallback)(function (value) {
    cancelAnimationFrame(ref.current);
    ref.current = requestAnimationFrame(function () {
      return setState(value);
    });
  }, []);
  (0, useWillUnmount_1["default"])(function () {
    cancelAnimationFrame(ref.current);
  });
  return [state, setRafState];
}
exports["default"] = useRafState;